module.exports = __webpack_public_path__ + "static/media/tshirt2.617c317e.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Images/tshirt2.PNG
// module id = 78
// module chunks = 0